import { DOMUtils } from '../../DOM/DOMUtils';
import { TourConfig } from '../../../types/TourConfig';

export class TourLoaderController {
  constructor(private readonly domUtils: DOMUtils) {}

  show(component?: TourConfig['loaderComponent']) {
    this.domUtils.showLoader(component);
  }

  hide() {
    this.domUtils.hideLoader();
  }
}
